import { render, staticRenderFns } from "./relatorioAtendimentos.vue?vue&type=template&id=1bc7ba27&scoped=true"
import script from "./relatorioAtendimentos.vue?vue&type=script&lang=js"
export * from "./relatorioAtendimentos.vue?vue&type=script&lang=js"
import style0 from "./relatorioAtendimentos.vue?vue&type=style&index=0&id=1bc7ba27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc7ba27",
  null
  
)

export default component.exports